// extracted by mini-css-extract-plugin
export default {"page-tool-sgd-impact-synthesis":"styles_page-tool-sgd-impact-synthesis__L--R1"};